import { Paper as MuiPaper } from "@mui/material"
import { makeStyles } from "@mui/styles"
import { flow } from "fp-ts/es6/function"
import T from "prop-types"
import { of, prop } from "ramda"
import { cx } from "ramda-extension/es"
import { createElement as h } from "react"

const useDynamicStyles = makeStyles(() => ({
  root: {
    padding: flow(prop("padding"), of),
  },
}))

export const Paper = ({ children, className, padding = [20, 30], elevation = 0, square = true }) =>
  h(
    MuiPaper,
    {
      className: cx(className, prop("root", useDynamicStyles({ padding }))),
      ...{ elevation, square },
    },
    children,
  )

Paper.propTypes = {
  children: T.oneOfType([T.element, T.arrayOf(T.element)]),
  className: T.string,
  padding: T.arrayOf(T.oneOfType([T.number, T.string])),
}
